import React from 'react';
import '../applications-css/Application.css'
import "../applications-css/Othello.css";
import win_icon from "../icons/check-0.png";
const blackCircle = <span role="img" aria-label="blackCircle" data-testid="blackCircle">⚫</span>
const whiteCircle = <span role="img" aria-label="whiteCircle" data-testid="whiteCircle">⚪</span>

class Othello extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 8,
      width: 8,
      tilesPlayed: 4,
      currentPlayer: "Black",
      consecutivePasses: 0,
      board: []
    }
    this.cellClickHandler = this.cellClickHandler.bind(this);
  }

  componentDidMount() {
    let array = [];
    this.create2dBoard(array);
    this.setState({
      board: array
    });
  }

  create2dBoard(array) {
    for(let i = 0; i < this.state.width; i++) {
      let newRow = new Array(this.state.height);
      for(let j = 0; j < this.state.height; j++) {
        newRow[j] = "";
      }
      array.push(newRow);
    }
    array[this.state.width / 2 - 1][this.state.width / 2 - 1] = whiteCircle
    array[this.state.width / 2][this.state.width / 2] = whiteCircle
    array[this.state.width / 2 - 1][this.state.width / 2] = blackCircle
    array[this.state.width / 2][this.state.width / 2 - 1] = blackCircle
  }

  createBoard() {
    let cellClickHandler = this.cellClickHandler;
    return(
      <div id="othelloGrid">
      {this.state.board.map(function(row, xIndex) {
        return row.map(function(cell, yIndex) {
          return(
            <OthelloSquare
              location={[xIndex, yIndex]}
              actualValue={cell}
              cellClickHandler = {cellClickHandler}
              key={[xIndex, yIndex]}
            />
          );
        })
      })}
      </div>
    )
  }

  passHandler() {
    let nextPlayer = (this.state.currentPlayer === "Black") ? "White" : "Black";
    let newConsecutivePasses = this.state.consecutivePasses + 1;
    if(newConsecutivePasses === 2) {
      console.log("no more moves")
      this.winHandler();
    }
    this.setState({
      consecutivePasses: newConsecutivePasses,
      currentPlayer: nextPlayer,
    })
  }

  cellClickHandler(location) {
    if(this.state.tilesPlayed === this.state.height * this.state.width) {
      console.log("no more moves")
      this.winHandler();
    }
    let x = location[0];
    let y = location[1];
    let newBoard = this.state.board;
    let tilesToFlip = this.findFlippableTiles(newBoard, x, y);
    let tilesFlipped = this.applyMove(newBoard, tilesToFlip);
    if(tilesFlipped > 0) {
      let nextPlayer = (this.state.currentPlayer === "Black") ? "White" : "Black";
      let newTilesPlayed = this.state.tilesPlayed + 1;
      let newConsecutivePasses = 0;
      this.setState({
        consecutivePasses: newConsecutivePasses,
        tilesPlayed: newTilesPlayed,
        currentPlayer: nextPlayer,
        board: newBoard
      })
    }
  }

  isValidSpace(x, y) {
    if(x > this.state.width - 1 || y > this.state.height - 1) {
      return false;
    }
    else if(x < 0 || y < 0) {
      return false;
    }
    else {
      return true;
    }
  }

  findFlippableTiles(array, x, y) {
    let playerColor = (this.state.currentPlayer === "Black") ? blackCircle : whiteCircle;
    let opponentColor = (this.state.currentPlayer === "Black") ? whiteCircle : blackCircle;
    let flippableTiles = [];
    let deltas = [
                  [-1, -1], [-1, 0], [-1, 1],
                  [0, -1], [0, 1],
                  [1, -1], [1, 0], [1, 1]
                ];
    for (let i = 0; i < deltas.length; i++) {
      let delta = deltas[i];
      let flipped = this.findFlippablesInDirection(array, x, y, delta[0], delta[1], playerColor, opponentColor);
      if(flipped.length !== 0) {
        for(let j = 0; j < flipped.length; j++) {
          flippableTiles.push(flipped[j]);
        }
      }
    }
    // console.log(flippableTiles);
    if(flippableTiles.length > 0) {
      array[x][y] = playerColor;
    }
    return flippableTiles;
  }

  // pretend we're using straight down, e.g. [x + 1, y]
  findFlippablesInDirection(array, x, y, xDelta, yDelta, playerColor, opponentColor) {
    let multiplier = 1;
    let tempFlipped = [];
    let lastColor = "";
    let xToCheck = x + (xDelta * multiplier);
    let yToCheck = y + (yDelta * multiplier);
    while(this.isValidSpace(xToCheck, yToCheck)) {
      lastColor = array[xToCheck][yToCheck];
      if(array[xToCheck][yToCheck] === playerColor) {
        break;
      }
      if(array[xToCheck][yToCheck] === "") {
        break;
      }
      tempFlipped.push([xToCheck, yToCheck]);
      multiplier++;
      xToCheck = x + (xDelta * multiplier);
      yToCheck = y + (yDelta * multiplier);
    }
    if(lastColor === opponentColor || lastColor === "") {
      tempFlipped = [];
    }
    return tempFlipped;
  }

  applyMove(array, tilesToFlip) {
    for (let i = 0; i < tilesToFlip.length; i++) {
      let x = tilesToFlip[i][0];
      let y = tilesToFlip[i][1];
      let playerColor = (this.state.currentPlayer === "Black") ? blackCircle : whiteCircle;
      let opponentColor = (this.state.currentPlayer === "Black") ? whiteCircle : blackCircle;
      if(array[x][y] === playerColor) {
        array[x][y] = opponentColor;
      }
      else {
        array[x][y] = playerColor;
      }
    }
    return tilesToFlip.length;
  }

  winHandler() {
    let blackPieces = 0;
    let whitePieces = 0;
    for(let i = 0; i < this.state.width; i++) {
      for(let j = 0; j < this.state.height; j++) {
        let space = this.state.board[i][j];
        if(space === blackCircle) {
          blackPieces++;
        }
        if(space === whiteCircle) {
          whitePieces++;
        }
      }
    }
    if(blackPieces === whitePieces) {
      this.props.appLauncherHandler(null, "Popup Window", this.tieMessage);
    }
    else if(blackPieces > whitePieces) {
      this.props.appLauncherHandler(null, "Popup Window", this.blackWinMessage);
    }
    else {
      this.props.appLauncherHandler(null, "Popup Window", this.whiteWinMessage);
    }

  }

  blackWinMessage() {
    return(
      <span>
        <img width="32px" src={win_icon} draggable="false" alt={""}/>
        <p>Black wins! Open a new window to play again.</p>
      </span>
    );
  }

  whiteWinMessage() {
    return(
      <span>
        <img width="32px" src={win_icon} draggable="false" alt={""}/>
        <p>White wins! Open a new window to play again.</p>
      </span>
    );
  }

  tieMessage() {
    return(
      <span>
        <img width="32px" src={win_icon} draggable="false" alt={""}/>
        <p>Tie game! Open a new window to play again.</p>
      </span>
    );
  }

  render() {
    return(
      <div id="othelloWrapper" className="outsideWrapper">
        <div id="othelloHeader">
          <button className="unclickedButton" data-testid="current-player" style={{pointerEvents: "none",}}>
            Player: {this.state.currentPlayer}
          </button>
          <button className="unclickedButton" data-testid="pass-button"
            onClick = {() => this.passHandler()}>
              Pass
          </button>
        </div>
        {this.createBoard()}
      </div>
    )
  }
}


class OthelloSquare extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(location) {
    this.props.cellClickHandler(location);
  }

  render() {
    let pointerEvents = "auto";
    let currentView = this.props.actualValue;
    if(currentView === blackCircle || currentView === whiteCircle) {
      pointerEvents = "none";
    }
    let buttonTitle = "cell-[" + this.props.location + "]"
    return(
      <div id="othelloCell">
        <button className="unclickedButton" ref="othelloButton"
          data-testid={buttonTitle}
          onClick = {() => this.clickHandler(this.props.location)}
          style={{
            pointerEvents: pointerEvents,
            fontWeight: "bold"
          }}
        >
          {currentView}
        </button>
      </div>
    )
  }
}

export default Othello;
